import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class LegalObligationTemplates extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'legalobligation',
            data: null,
            loading: true,
            id_to_remove: null,
            fiscalYear: this.getCurrentPersianYear(), 
            generating: false,
            showModal: false,
            contracts: [],
            templates: [],
            selectedContractIds: [],
            selectedTemplateIds: [],
        };
    }

    componentDidMount() {
        this.refreshData();
    }
    getCurrentPersianYear() {
        const now = new Date();
        const gregorianYear = now.getFullYear();
        const month = now.getMonth() + 1; 
        const day = now.getDate();
        if (month < 3 || (month === 3 && day < 21))
            return gregorianYear - 622;
        else
            return gregorianYear - 621;
    }
    refreshData(e) {
        if (e) e.preventDefault();
        this.setState({ loading: true });

        this.httpPost(`api/v1/legalobligation/templates/list`, {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({ data: { records: data.templates, recordsCount: data.templates.length,global:data.global }, loading: false });
                } else if (data.status === -5) window.location.href = "/access-denied"; else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    confirmRemove(id) {
        this.setState({ id_to_remove: id });
    }

    remove() {
        this.httpPost(`api/v1/legalobligation/templates/remove`, { id: this.state.id_to_remove })
            .then(data => {
                if (data.status === 1) {
                    this.showSuccessMessage('قالب حذف شد');
                    this.setState({ id_to_remove: null }, () => this.refreshData());
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    openModal() {
        this.setState({ showModal: true });

        this.httpPost('api/v1/legalobligation/activecontracts', {})
            .then(data => this.setState({ contracts: data.contracts || [] }))
            .catch(() => { });

        this.httpPost('api/v1/legalobligation/templates/list', {})
            .then(data => this.setState({ templates: data.templates || [] }))
            .catch(() => { });
    }

    toggleContract(id) {
        const arr = [...this.state.selectedContractIds];
        const idx = arr.indexOf(id);
        if (idx > -1) arr.splice(idx, 1);
        else arr.push(id);
        this.setState({ selectedContractIds: arr });
    }

    toggleTemplate(id) {
        const arr = [...this.state.selectedTemplateIds];
        const idx = arr.indexOf(id);
        if (idx > -1) arr.splice(idx, 1);
        else arr.push(id);
        this.setState({ selectedTemplateIds: arr });
    }

    generateObligations() {
        const year = parseInt(this.state.fiscalYear);
        if (!year) {
            this.showErorrMessage('لطفاً سال مالی معتبر وارد کنید');
            return;
        }
        const { selectedContractIds, selectedTemplateIds } = this.state;
        if (selectedContractIds.length === 0) {
            this.showErorrMessage('حداقل یک قرارداد انتخاب کنید');
            return;
        }
        if (selectedTemplateIds.length === 0) {
            this.showErorrMessage('حداقل یک قالب انتخاب کنید');
            return;
        }

        this.setState({ generating: true, showModal: false });
        this.httpPost('api/v1/legalobligation/generate', {
            fiscalYear: year,
            contractIds: selectedContractIds,
            templateIds: selectedTemplateIds
        }).then(data => {
            this.setState({ generating: false });
            if (data.status === 1) {
                this.showSuccessMessage(data.message);

                this.setState({ selectedContractIds: [], selectedTemplateIds: [] });
            } else {
                this.showErorrMessage(data.message);
            }
        });
    }

    renderForm() {
        const records = this.state.data?.records || [];
        const { contracts, templates, selectedContractIds, selectedTemplateIds, showModal, fiscalYear, generating } = this.state;

        return (
            <div className="nk-content-body">

                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">قالب‌های تکالیف قانونی</h3>
                            <div className="nk-block-des text-soft">
                                <p>{records.length} قالب تعریف شده است</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <NavLink to="/legalobligationtemplate/new/" className="btn btn-primary">
                                                <em className="icon ni ni-plus"></em><span>افزودن قالب جدید</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="card card-bordered mb-3">
                    <div className="card-inner">
                        <h5 className="card-title">تولید وظایف قانونی</h5>
                        <div className="row g-3 align-items-end">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="form-label">سال مالی (شمسی)</label>
                                    <input type="number" className="form-control"
                                        value={fiscalYear}
                                        onChange={e => this.setState({ fiscalYear: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <button className="btn btn-success"
                                    onClick={() => this.openModal()}
                                    disabled={generating}>
                                    {generating ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm mr-2"></span>
                                            در حال تولید...
                                        </>
                                    ) : (
                                        <>
                                            <em className="icon ni ni-play-fill"></em> انتخاب و تولید
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                        <small className="text-muted">می‌توانید قراردادها و قالب‌های خاصی را برای تولید انتخاب کنید.</small>
                    </div>
                </div>

 
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        {records.length === 0 ? (
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text"><h6>توجه</h6><p>هیچ قالبی ثبت نشده است</p></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="card-inner p-0">
                                <table className="table table-bordered table-responsive">
                                    <thead>
                                        <tr>
                                            <th>ردیف</th>
                                            <th>عنوان</th>
                                            <th>سرویس</th>
                                            <th>نوع دوره</th>
                                            <th>قاعده سررسید</th>
                                            <th>اولویت</th>
                                            <th>فعال</th>
                                            <th>عملیات</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {records.map((t, idx) => (
                                            <tr key={t.id}>
                                                <td>{idx + 1}</td>
                                                <td>{t.title}</td>
                                                <td>{t.serviceTitle || '---'}</td>
                                                <td>{t.periodType === 'Monthly' ? 'ماهانه' :
                                                    t.periodType === 'Quarterly' ? 'فصلی' :
                                                        t.periodType === 'Yearly' ? 'سالانه' :
                                                            t.periodType === 'Daily' ? 'روزانه' :
                                                                t.periodType === 'FixedDate' ? 'تاریخ ثابت' : 'هفتگی'}</td>
                                                <td>{t.dueDayRule || `${t.dueDayOffset} روز`}</td>
                                                <td><span className={`badge ${t.priority === 4 ? 'badge-danger' : t.priority === 3 ? 'badge-warning' : 'badge-info'}`}>{t.priority}</span></td>
                                                <td>{t.isActive ? '✓' : '✗'}</td>
                                                <td>
                                                    <NavLink to={`/legalobligationtemplate/edit/${t.id}/`} className="btn btn-sm btn-primary">
                                                        <em className="icon ni ni-edit"></em>
                                                    </NavLink>
                                                    <button className="btn btn-sm btn-danger ml-1"
                                                        onClick={() => this.confirmRemove(t.id)}
                                                        data-bs-toggle="modal" data-bs-target="#modalConfirmRemove">
                                                        <em className="icon ni ni-trash"></em>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>

                {showModal && (
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">انتخاب قراردادها و قالب‌ها</h5>
                                    <button type="button" className="close" onClick={() => this.setState({ showModal: false })}>&times;</button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h6>قراردادهای فعال</h6>
                                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                {contracts.length === 0 && <p className="text-muted">هیچ قرارداد فعالی یافت نشد.</p>}
                                                {contracts.map(c => (
                                                    <div className="custom-control custom-checkbox" key={c.id}>
                                                        <input type="checkbox" className="custom-control-input" id={`c${c.id}`}
                                                            checked={selectedContractIds.includes(c.id)}
                                                            onChange={() => this.toggleContract(c.id)} />
                                                        <label className="custom-control-label" htmlFor={`c${c.id}`}>{c.title}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h6>قالب‌ها</h6>
                                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                {templates.length === 0 && <p className="text-muted">هیچ قالبی یافت نشد.</p>}
                                                {templates.map(t => (
                                                    <div className="custom-control custom-checkbox" key={t.id}>
                                                        <input type="checkbox" className="custom-control-input" id={`t${t.id}`}
                                                            checked={selectedTemplateIds.includes(t.id)}
                                                            onChange={() => this.toggleTemplate(t.id)} />
                                                        <label className="custom-control-label" htmlFor={`t${t.id}`}>{t.title}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-primary" onClick={() => this.generateObligations()}>تولید</button>
                                    <button className="btn btn-secondary" onClick={() => this.setState({ showModal: false })}>انصراف</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            this.getGlobalContainer(),
            <Header data={this.state.data} />,
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        {this.renderForm()}
                    </div>
                </div>
            </div>,
            <Footer />
        ];
        return contents;
    }
}